import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import {Container,Grid} from '@material-ui/core';
import {IoCalendar} from 'react-icons/io5';
import {useParams} from 'react-router-dom';
import News from '../../models/news.model';
import { useEffect } from 'react';
import moment from 'moment';
import { returnLimitedWords } from '../../utils/common.utils';
import Preloader from '../../components/PreLoader';
import { fetchNoticeBySlug } from '../../services/notice.service';
// import translate from '../../translation.json';
import { lang } from '../../config/app.config';
import { useSelector } from 'react-redux';
import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';

interface params{
  slug:string
}

const NoticeSingle:React.FC = ()=>{

  const {slug} =  useParams<params>();

  const [notice,setNotice] = React.useState<News|undefined>(undefined);
  const [loading,setLoading] = React.useState<boolean>(false);

  const fetchNotice = async() => {
    setLoading(true);
    const notice = await fetchNoticeBySlug(slug) || undefined;
    setNotice(notice);
    setLoading(false)
  }

  useEffect(()=>{
    fetchNotice();
  },[slug]) //eslint-disable-line

  const stateTr = useSelector((state:{translation:TranslationState})=>state.translation);


  return(
    <>
    {
    !loading?
    notice?
    <>
     <Breadcrumb routes={[{title:stateTr.translation?stateTr.translation.notice[lang==='np'?"value_np":"value_en"]:"",path:"/notice"},{title:returnLimitedWords(notice.title,60)|| ''}]} slug="notice"/>
      <div className="text-center curveBackground">
        <h3 className="ecn-title-inv text-26">{notice.title|| ''}</h3>
      </div>
      <div className="section-padding-2 ">
        <Container maxWidth="lg">
          <Grid container className="justify-content-center">
            <Grid item xs={12} md={8} >
              {
                notice.image?<img src={notice.image || ''} alt="" className="img-fluid mb-1"/>:''
              }
              
              <p className="text-13-primary display-flex align-item-center"><IoCalendar className="mr-05"/>{moment(notice.created_at).format('MMMM Do YYYY')}</p>

              <div className="blog-details" dangerouslySetInnerHTML={{ __html: notice.body|| '' }}>
               </div>
            </Grid>
            
          </Grid>
        </Container>
      </div>
      </>:
      <h3 className="text-center section-break-4 text-28-primary">
        Sorry news not found!!
      </h3> // no news
      :<Preloader/>} 
      {/* <SimlarBlogs/> */}
    </>
  );
}

export default NoticeSingle;